import Link from 'next/link'
import { ITextProps, Text } from './Text'

interface CustomLinkProps extends ITextProps {
  href: string
  target?: string
  rel?: string
}

export const CustomLink = ({
  href,
  target = '_self',
  rel = 'noopener noreferrer',
  children,
  ...rest
}: CustomLinkProps) => {
  return (
    <Link href={href} target={target} rel={rel}>
      <Text as={'span'} colorClass="text-info" {...rest}>
        {children}
      </Text>
    </Link>
  )
}
